import React, { Component } from 'react';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';
import styles from './Wireframe.scss';
import RightWireframe from '../RightWireframe';

class Wireframe extends Component {
  render() {
    const { client, t } = this.props;
    return (
      <div className={this.props.className}>
        {client ? (
          <div>
            <div className={styles.NavLinks}>
              <div className={styles.NavLink}>
                {t('components.building.main.leftWireframe.photo')}
              </div>
              <div className={styles.NavLink}>
                {t('components.building.main.leftWireframe.info')}
              </div>
              <div className={styles.NavLink}>
                {t('components.building.main.leftWireframe.flats')}
              </div>
            </div>
            <div className={styles.Info}>
              <div className={styles.InfoInner}>
                <div className={styles.Column}>
                  <span className={styles.Count} />
                  <span className={styles.Name} />
                </div>
                <div className={styles.Column}>
                  <span className={styles.Count} style={{ width: 48 }} />
                  <span className={styles.Name} />
                </div>
                <div className={styles.Column}>
                  <span className={styles.Count} style={{ width: 138 }} />
                  <span className={styles.Name} style={{ width: 108 }} />
                </div>
                <div className={styles.Column}>
                  <span className={styles.Count} style={{ width: 167 }} />
                  <span className={styles.Name} style={{ width: 167 }} />
                </div>
              </div>
              <RightWireframe className={cn(styles.RightRow, styles.MobileOnly)} />
              <div className={styles.FeaturesWrap}>
                <div className={cn(styles.Title, styles.MobileOnly)}>
                  {t('components.building.main.leftWireframe.advantages')}
                </div>
                <div className={styles.Features}>
                  <div className={styles.Feature}>
                    <div className={styles.FeatureImg}></div>
                    <div className={styles.FeatureName}></div>
                  </div>
                  <div className={styles.Feature}>
                    <div className={styles.FeatureImg}></div>
                    <div className={styles.FeatureName}></div>
                  </div>
                  <div className={styles.Feature}>
                    <div className={styles.FeatureImg}></div>
                    <div className={styles.FeatureName}></div>
                  </div>
                  <div className={styles.Feature}>
                    <div className={styles.FeatureImg}></div>
                    <div className={styles.FeatureName}></div>
                  </div>
                  <div className={styles.Feature}>
                    <div className={styles.FeatureImg}></div>
                    <div className={styles.FeatureName}></div>
                  </div>
                  <div className={styles.Feature}>
                    <div className={styles.FeatureImg}></div>
                    <div className={styles.FeatureName}></div>
                  </div>
                </div>
              </div>
              <div className={styles.MoreLink}></div>
              <div className={styles.About}>
                <div className={styles.Inner}>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      <span className={styles.MobileHidden}>
                        {t('components.building.main.leftWireframe.commonAbout')}
                      </span>
                      <span className={styles.MobileOnly}>
                        {t('components.building.main.leftWireframe.about')}
                      </span>
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Class)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Material)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Type)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Parking)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Territory)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.ToSea)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Height)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      {t('components.building.main.leftWireframe.com')}
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Heating)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Electricity)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Sewerage)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Water)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.Inner}>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      <span className={styles.MobileHidden}>
                        {t('components.building.main.leftWireframe.decor')}
                      </span>
                      <span className={styles.MobileOnly}>
                        {t('components.building.main.leftWireframe.about')}
                      </span>
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Class)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Material)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Type)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Parking)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Territory)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.ToSea)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Height)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      {t('components.building.main.leftWireframe.pay')}
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Heating)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Electricity)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Sewerage)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Water)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.Housing}>
                <div className={styles.HousingTitle}></div>
                <div className={styles.HousingInner}>

                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className={cn(styles.Gallery)}>
              <div className={styles.Inner}>
                <div className={styles.Slider} />
              </div>
            </div>
            <div className={styles.Info}>
              <div className={styles.InfoInner}>
                <div className={styles.Column}>
                  <span className={styles.Count} />
                  <span className={styles.Name} />
                </div>
                <div className={styles.Column}>
                  <span className={styles.Count} style={{ width: 48 }} />
                  <span className={styles.Name} />
                </div>
                <div className={styles.Column}>
                  <span className={styles.Count} style={{ width: 138 }} />
                  <span className={styles.Name} style={{ width: 108 }} />
                </div>
                <div className={styles.Column}>
                  <span className={styles.Count} style={{ width: 167 }} />
                  <span className={styles.Name} style={{ width: 167 }} />
                </div>
              </div>
              <RightWireframe className={cn(styles.RightRow, styles.MobileOnly)} />
              <div className={styles.DescriptionFeatures}>
                <div className={styles.Description}>
                  <div className={cn(styles.Title, styles.TitleDescrip)}>
                    {t('components.building.main.leftWireframe.aboutHouse')}
                  </div>
                  <div className={styles.Lines}>
                    <span className={styles.Line} />
                    <span className={styles.Line} />
                    <span className={styles.Line} />
                  </div>
                </div>
                <div className={styles.FeaturesWrap}>
                  <div className={cn(styles.Title)}>
                    {t('components.building.main.leftWireframe.advantages')}
                  </div>
                  <div className={styles.Features}>
                    <div className={styles.Feature}>
                      <div className={styles.FeatureImg}></div>
                      <div className={styles.FeatureName}></div>
                    </div>
                    <div className={styles.Feature}>
                      <div className={styles.FeatureImg}></div>
                      <div className={styles.FeatureName}></div>
                    </div>
                    <div className={styles.Feature}>
                      <div className={styles.FeatureImg}></div>
                      <div className={styles.FeatureName}></div>
                    </div>
                    <div className={styles.Feature}>
                      <div className={styles.FeatureImg}></div>
                      <div className={cn(styles.FeatureName)}></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.About}>
                <div className={styles.Inner}>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      <span className={styles.MobileHidden}>
                        {t('components.building.main.leftWireframe.commonAbout')}
                      </span>
                      <span className={styles.MobileOnly}>
                        {t('components.building.main.leftWireframe.about')}
                      </span>
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Class)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Material)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Type)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Parking)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Territory)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.ToSea)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Height)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>

                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      {t('components.building.main.leftWireframe.com')}
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Heating)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Electricity)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Sewerage)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Water)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.About}>
                <div className={styles.Inner}>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      {t('components.building.main.leftWireframe.decor')}
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Class)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Material)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Type)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Parking)}>
                        <div className={styles.Title}></div>
                        <div className={styles.Description}></div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.InfoBlock}>
                    <div className={styles.AboutTitle}>
                      {t('components.building.main.leftWireframe.pay')}
                    </div>
                    <div className={styles.InfoBlockInner}>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Description}></div>
                        <div className={styles.Title}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Description}></div>
                        <div className={styles.Title}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Description}></div>
                        <div className={styles.Title}></div>
                      </div>
                      <div className={cn(styles.InfoItem, styles.Gas)}>
                        <div className={styles.Description}></div>
                        <div className={styles.Title}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.Housing}>
                <div className={styles.HousingTitle}>
                  {t('components.building.main.leftWireframe.corp')}
                  <span></span>
                </div>
                <div className={styles.HousingInner}>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(Wireframe);



// WEBPACK FOOTER //
// ./src/components/Building/Main/LeftWireframe/Wireframe.js